<template>
    <div>
        <h4><span>{{ label }}</span></h4>


            <textarea name="comment" class="comment form-control"   @change="change"  v-model="comment">{{ value }}</textarea>

    </div>
</template>
<script>

export default {
    props: ['value','label'],
    data: function() {
            return {
                comment: this.value
            }
    },
    methods: {
        change: function() {
                this.$emit('input', this.comment);
                // this.$parent.$root.megjegyzes = this.megjegyzes;
        }
    },
    computed: {
        // edited: function() {
        //     this.$root.megjegyzes = this.megjegyzes;
        // }
    }
}
</script>
